import { render, staticRenderFns } from "./VerificationModal.vue?vue&type=template&id=04c7fe80&scoped=true&"
import script from "./VerificationModal.vue?vue&type=script&lang=ts&"
export * from "./VerificationModal.vue?vue&type=script&lang=ts&"
import style0 from "./VerificationModal.vue?vue&type=style&index=0&id=04c7fe80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c7fe80",
  null
  
)

export default component.exports